import React from "react";
import { Text, Layout, Image, Meta, Heading } from "../../../components";
import Styles from "./about.module.scss";
import { getBasePath } from "../../../helper";

const Magician = () => {
  const basePath = getBasePath();
  return (
    <Layout
      title1="Upspot the"
      title2="magician of Web Development Services"
      // description="Magician of Web Development Services"
    >
      <Meta
        title="magician of Web Development Services "
        description="Upspot the magician of Web Development Services."
        pageUrl="blogs/magician-of-web-development-services"
      />
      <div className={`section ${Styles.aboutPage}`}>
        <div className="container">
          <Image src="../../../images/blog2.png" className={"w-100"} />

          <div className="col-md-12 col-lg-12 mt-5 mb-2">
            <div>
              <Text variant={"md"} strong={"regular"}>
                In the recent contemporary era, websites are no longer a sign of
                rich businesses. Perhaps it's a basic amenity for the
                commencement of business, to cater to the cutting edge
                competition. It acts as the front court player in the
                competitive environment of the business development era. As the
                internet continues to be the core platform to grow the business,
                the website as the show store to increase the online presence of
                a company.
              </Text>
            </div>
          </div>
          <div className="col-md-12 col-lg-12 mt-3 mb-5">
            <div>
              <Text variant={"md"} strong={"regular"}>
                Upspot, one among the magisterial Digital Marketing agencies and
                pioneers of{" "}
                <a
                  href="https://upspot.in/service/software-web-development"
                >
                  web development services
                </a>{" "}
                from Central India, acknowledge the need of well crafted
                websites for an enterprise. We cater our customers with well
                designed websites that focus on minimalist, catchy and trendy
                aesthetics with a lot of detailing. This gives the users a high
                quality experience which not only increases the footfall but
                also converts them into recurring customers.
              </Text>
            </div>
          </div>
          <div className="row ">
            <Heading
              headingText={"Understanding the need of clients"}
              headingType={"h2"}
              strong={"bold"}
              className={"mb-3"}
            />
          </div>
          <div className="col-md-12 col-lg-12 mt-0">
            <div>
              <Text variant={"md"} strong={"regular"}>
                Upspot is very proficient in practising the alchemy of web
                development services and AI in marketing. It can effortlessly
                build the digital empire for the businesses, but prior to diving
                into the codes of web development it makes sure to understand
                the needs of its clients.
              </Text>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Identity of the Brand"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  Upspot identifies the USP, moat, UVP product/service SKUs with
                  the help of its highly qualified and experienced team and
                  re-rectifies it with the help of AI tools used in the digital
                  marketing space.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Tap target audience"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  Upspot focuses on pitching the large audience and converting
                  them into the imperishable customers. We conduct the market
                  research with the help of its specially designed AI tools.
                  These tools are tailor made by Upspot depending on the type of
                  business which help the business to find out its product
                  market fit, target market and target audience.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Find Purpose of Website"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  Upspot also consults the business to find the purpose of
                  businesses to subscribe to the services from Upspot, And
                  believes in giving the right guidance to its customers to
                  fulfil their desired goals.
                </Text>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-12 mt-5 mb-5">
            <div>
              <Heading
                headingText={
                  "Understanding the need of web development services with the help of AI in Marketing"
                }
                headingType={"h2"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"First Impression"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  In the digital era the impression generates a lot of
                  attention, as in just micros and nanos it captures the space
                  for virality. Upspot understands the need for well placed
                  aesthetics and fetches the attention of the visitors.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Responsive Design"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  With the increase in the trend of tech devices, Upspot ensures
                  to build a flawless and user friendly interface which can be
                  adjusted for all the devices.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Optimised Performance"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  This digital era is for quick things. The slow ones are
                  eventually demolished, Upspot here takes charge to speed up
                  the website and eliminate the buffering icon from the website
                  interface with the help of AI tools used in the digital
                  marketing domain.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Leveraging AI in Web Development Services"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  In this digital age the AI has emerged as a new trailblazer
                  for the businesses. The businesses who decided to go ahead
                  with AI are rapidly flourishing. Upspot personalised the need
                  of business with the tint of AI.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Predictive Analytics"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  Data Analysis is key to open the doors of growth for the
                  business. The in house AI tools by the Upspot analyse the
                  market trends and patterns, works on the maximisation of the
                  ROI.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Client consultation"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  Upspot gives the comprehensive consultation to the clients and
                  majorly focuses on the growth of the business with
                  profitability, with this it tries to reach more customers.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Strategic Planning"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  Planning is the root for the execution, Upspot gives the most
                  practical strategies to the business and also to clients who
                  want to do their personal branding. It keeps the execution as
                  its focus point and gives the practical view to the clients
                  and does not entertain the dilemmas.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Responsive Development"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  Upspot ensures the cross platform compatibility of the website
                  which can work on any hi-tech device with any visibility
                  resolution by applying the latest coding structures and code
                  languages.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Backend Development"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  Backend infrastructure is the powerhouse of the website. With
                  a team of experts and unique AI tools, Upspot designs a super
                  strong and glitch free backend for its customers.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Testing and Quality Management"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  Upspot focuses on the end to end testing of the business and
                  its product, later that it tests the website with its hi-tech
                  tools by checking the performance, quality and compatibility
                  of the website made for the client. The testing is done on
                  various devices to provide a seamless experience to the users.
                </Text>
              </div>
            </div>
          </div>
          <div className="row justify-content-between mt-3 mb-5">
            <div className="col-md-12 col-lg-4">
              <Heading
                headingText={"Ongoing Lifetime Support"}
                headingType={"h4"}
                strong={"bold"}
                className={"mb-4"}
              />
            </div>
            <div className="col-md-12 col-lg-7">
              <div>
                <Text variant={"md"} strong={"regular"}>
                  Trust is the base for consumers to work with the{" "}
                  <a href="https://upspot.in/">
                    digital marketing agency
                  </a>
                  . Upspot being the renowned digital marketing agency in
                  Indore, ensures 24/7 after delivery services to its clients.
                  It provides maintenance and resolution services post sending
                  the website to slipway and serves its customers with utmost
                  dignity.
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Magician;
